import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import { CUSTOMER_WEBSITE_ROUTE } from "../../components/strings";
import CustomerForm from "../../components/customers/customer-form";
import CustomerView from "../../components/customers/customer-view";
import CustomerLeads from "../../components/customers/customer-leads";
import CustomersTable from "../../components/customers/customers-table";
import CustomerFunnels from "../../components/customers/customer-funnels";
import CustomerOverview from "../../components/customers/customer-overview";
import CustomerInvoices from "../../components/customers/customer-invoices";
import CustomerPerformance from "../../components/customers/customer-performance";
import CustomerWebsiteTabs from "../../components/customers/website/website-tabs";

const CustomerPage = () => {
  return (
    <>
      <Routes>
        <Route index element={<CustomersTable />} />
        <Route path="new" element={<CustomerForm />} />
        <Route path=":id/edit" element={<CustomerForm />} />
        <Route path=":id" element={<CustomerView />}>
          <Route index element={<CustomerOverview />} />
          <Route path="overview" element={<CustomerOverview />} />
          <Route path="funnels" element={<CustomerFunnels />} />
          <Route path="leads" element={<CustomerLeads />} />
          <Route path="performance" element={<CustomerPerformance />} />
          <Route path="invoices" element={<CustomerInvoices />} />
          <Route path={CUSTOMER_WEBSITE_ROUTE}>
            <Route index element={<CustomerWebsiteTabs />} />
            <Route path=":websiteTabRoute" element={<CustomerWebsiteTabs />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/dashboard/customers" />} />
      </Routes>
      <Outlet />
    </>
  );
};
export default CustomerPage;
